export default (function (compositAddress) {
  return compositAddress ? compositAddress.split('?dt=') : [''];
});